commusoftCommon.service('underscore', function() {
    var underscore = angular.module('underscore', []);
    underscore.factory('_', function() {
        return window._;
    });
});